import Swiper from "swiper/bundle";

const initializeSlider = (brandsSlider) => {
  const getCountSlides = () => {
    const container = brandsSlider;
    const containerWidth = container.offsetWidth;
    return Math.round(containerWidth / 150);
  };

  const createSlides = (items) => {
    const count = getCountSlides();
    let currentItems = items.slice();

    do {
      currentItems.push(...items);
    } while (currentItems.length < count * 2);

    return currentItems;
  };

  const slideList = brandsSlider.querySelector(".swiper-wrapper");
  const slides = Array.from(brandsSlider.querySelectorAll(".swiper-slide"));

  if (getCountSlides() * 2 > slides.length) {
    const newSlides = createSlides(slides);
    slideList.innerHTML = "";
    newSlides.forEach((newSlide) => {
      const newNodeEl = newSlide.cloneNode(true);
      slideList.appendChild(newNodeEl);
    });
  }

  new Swiper(brandsSlider, {
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 0, 
      disableOnInteraction: false, 
    },
    noSwiping: true,
    speed: 3500,
    spaceBetween: 32,
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      1024: {
        spaceBetween: 48,
      },
    },
  });
};

const BrandsSlider = () => {
  const brandsSliders = [...document.querySelectorAll('.brands__slider')];

  if (brandsSliders.length > 0) {
    const observerOptions = {
      root: document,
      rootMargin: "100% 0px 100% 0px", 
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          initializeSlider(entry.target);
          observer.unobserve(entry.target); 
        }
      });
    }, observerOptions);

    brandsSliders.forEach(brandsSlider => {
      observer.observe(brandsSlider);
    });
  }
};

export default BrandsSlider;
